<template>
  <!-- One notification, rendered by the component for its type (US 9372). Used by the notifications panel and page. -->
  <div class="notification-item"
       :class="{ 'notification-item--unread': !notification.read_at }"
       @click.capture="handleClick"
  >
    <component :is="renderer" :notification="notification" v-if="renderer"/>
  </div>
</template>

<script>
  import ValidationNotification from '@/components/notification/ValidationNotification.vue';
  import OwnerNotification from '@/components/notification/OwnerNotification.vue';
  import ReportNotification from '@/components/notification/ReportGeneratedNotification.vue';
  import ProjectCreatedNotification from '@/components/notification/ProjectCreatedNotification.vue';
  import ProjectCompletedNotification from '@/components/notification/ProjectCompletedNotification.vue';
  import ExportNotification from '@/components/notification/ExportNotification.vue';
  import PolicyDocumentAddedNotification from '@/components/notification/PolicyDocumentAddedNotification.vue';
  import PolicyDocumentUpdatedNotification from '@/components/notification/PolicyDocumentUpdatedNotification.vue';
  import PolicyDocumentPublishedNotification from '@/components/notification/PolicyDocumentPublishedNotification.vue';
  import PolicyDocumentReadyToPublishNotification from '@/components/notification/PolicyDocumentReadyToPublishNotification.vue';
  import AttachmentNotification from '@/components/notification/AttachmentsGeneratedNotification.vue';
  import CollectionTaskComment from '@/components/notification/CollectionTaskComment.vue';
  import CollectionTaskCompleted from '@/components/notification/CollectionTaskCompleted.vue';
  import CollectionTaskReopened from '@/components/notification/CollectionTaskReopened.vue';
  import CollectionTestSentBack from '@/components/notification/CollectionTestSentBack.vue';
  import CollectionOeReminder from '@/components/notification/CollectionOeReminder.vue';
  import TaskComment from '@/components/notification/TaskComment.vue';
  import ProjectOverdueNotification from '@/components/notification/ProjectOverdueNotification.vue';
  import AuditPlanImportReadyNotification from '@/components/notification/AuditPlanImportReadyNotification.vue';

  const RENDERERS = {
    Validation: ValidationNotification,
    Owner: OwnerNotification,
    ReportGenerated: ReportNotification,
    ProjectCreated: ProjectCreatedNotification,
    ProjectCompleted: ProjectCompletedNotification,
    ExportGenerated: ExportNotification,
    PolicyDocumentAdded: PolicyDocumentAddedNotification,
    PolicyDocumentUpdated: PolicyDocumentUpdatedNotification,
    PolicyDocumentPublished: PolicyDocumentPublishedNotification,
    PolicyDocumentReadyToPublish: PolicyDocumentReadyToPublishNotification,
    AttachmentsGenerated: AttachmentNotification,
    CollectionTaskComment: CollectionTaskComment,
    CollectionTaskCompleted: CollectionTaskCompleted,
    CollectionTaskReopened: CollectionTaskReopened,
    CollectionTestSentBack: CollectionTestSentBack,
    CollectionOeReminder: CollectionOeReminder,
    TaskComment: TaskComment,
    ProjectOverdue: ProjectOverdueNotification,
    AuditPlanImportReady: AuditPlanImportReadyNotification,
  };

  export default {
    name: 'NotificationItem',
    props: {
      notification: {
        type: Object,
        required: true
      }
    },
    computed: {
      renderer() {
        let type = (this.notification.type || '').split('\\').pop();
        return RENDERERS[type] || null;
      }
    },
    methods: {
      // Clicking a notification (its links included) marks it as read; the parent does the request.
      handleClick() {
        this.$emit('open', this.notification);
      }
    }
  }
</script>
